import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import EventGamePredictionModel from "./Prediction/EventGamePredictionModel";

export default class EventGamePredictionsModel {
  public meta: MetaModel = new MetaModel();
  public data: EventGamePredictionModel[] = [];
}
